import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import Fontstyling from "../../../components/common/comman";
import { Link } from "react-router-dom";
import MedicalPlanModal from "../../../components/common/Modal/MedicalPlanModal";
import { GetClientsMedicalPlanDetails } from "../../../api/User/Hub/medicalplanApi";
import moment from "moment";
import toastFile from "../../../Service/ToastFile";
import DetailsHeader from "../../../components/common/Hub/DetailsHeader";
import CustomMaterialTable from "../../../components/common/CustomMaterialTable";

const MedicalPlanSetup = ({ navigate }) => {
  const user = useSelector((state) => state.userDetails.value);
  const client = useSelector((state) => state.clientData.value);
  const [medicalPlanData, setMedicalPlanData] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCarrier, setSelectedCarrier] = useState({});
  const [responseMessage, setResponseMessage] = useState("");
  const [witchAction, setWitchAction] = useState("add");
  const [selectedRow, setSelectedRow] = useState(null);

  const column = [
    {
      title: "Carrier",
      field: "Carrier",
    },
    {
      title: "Contract Start",
      field: "CMedicalPlanContractStart",
      render: (rowData) => moment(rowData.CMedicalPlanContractStart).format("MM-DD-yyyy"),
    },
    {
      title: "Contract End",
      field: "CMedicalPlanContractEnd",
      render: (rowData) => moment(rowData.CMedicalPlanContractEnd).format("MM-DD-yyyy"),
    },
    {
      title: "Funding Arrangement",
      field: "FundingName",
    },
    {
      title: "Stop Loss Carrier or Insurer",
      field: "StopLossName",
    },
    {
      title: "ISL / PP",
      field: "CMedicalPlanISL_PP",
      render :(rowData) => '$' + rowData.CMedicalPlanISL_PP.toFixed(2)
    },
    {
      title: "Plan Name",
      field: "CMedicalPlanName",
    },
    {
      title: "Plan Type",
      field: "CMedicalPlanType",
    },
    {
      title: "AV",
      field: "CMedicalPlanAV",
    },
    {
      title: "Tier Type",
      field: "CMedicalPlanTierType",
    },
  ];
  
  useEffect(() => {
    if (!modalShow) {
      setWitchAction("add");
    }
  }, [modalShow]);

  useEffect(() => {
    if (responseMessage === "rejectedRegion") {
      toastFile("Region Rejected");
    } else if (responseMessage === "error") {
      toastFile("failed to save")
    } else if (responseMessage !== "") {
      toastFile(responseMessage, 'success')
    }
    getMedicalPlanData();
    setResponseMessage("");
  }, [responseMessage, client]);

  const getMedicalPlanData = () => {
    if (client !== null) {
      setIsLoading(true);
      GetClientsMedicalPlanDetails(client?.clientID, user?.UD_id)
        .then((res) => {
          if(res?.status === 200 || res?.status === 204){
          setMedicalPlanData(res.data);
          setIsLoading(false);
          }
        })
        .catch((err) => setIsLoading(false));
    }
  };

  const deleteMedicalCarrier = (MedCarId) => {
    let payload = {
      MedCarID: MedCarId,
    };
  };
  return (
    <>
      {modalShow && <MedicalPlanModal
        show={modalShow}
        onHide={() => {
          setSelectedCarrier({});
          setModalShow(false);
        }}
        witchAction={witchAction}
        selectedCarrier={selectedCarrier}
        setResponseMessage={setResponseMessage}
        deleteMedicalCarrier={deleteMedicalCarrier}
        getData={getMedicalPlanData}
      />}
      <DetailsHeader setModalShow={setModalShow} setWitchAction={setWitchAction}/>
      
      <div className="mb-4" style={Fontstyling.heading}>
        Medical Plan Details:
      </div>
      <CustomMaterialTable
        isDelete={false}
        isExport={false}
        column={column}
        data={medicalPlanData}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        setWitchAction={setWitchAction}
        setSelectedRowData={setSelectedCarrier}
        setShowModal={setModalShow}
        isLoading={isLoading}
      />
      <div className="d-md-flex d-block align-items-center gap-3 mt-3">
        <Link
          className="text-nowrap"
          style={{ ...Fontstyling.savebutton, textDecoration: "none" }}
          to={"/HUBExperience/medicalcredentials"}
        >
          Save & Continue
        </Link>
        {/* <button
          style={Fontstyling.cancelbutton}
        >
          Cancel
        </button> */}
        <div style={Fontstyling.secondaryparagraph}>
          To edit pre-populated company information, please make changes in
          BenefitPoint and return to Infused Analytics
        </div>
      </div>
    </>
  );
};

export default MedicalPlanSetup;
